import { createSlice } from '@reduxjs/toolkit'
import { ROUTES } from '../config/routes';

const PM_STEP = ROUTES.PRICING_MATRIX.PRICING_MATRIX_STEP;
const initialState = {
    industry: null,
    [PM_STEP.GEOGRAPHIES]: [],
    [PM_STEP.TITLES]: [],
    [PM_STEP.IRLEVEL]: [],
    [PM_STEP.LOI]: null,
    [PM_STEP.TARGETABLE_SCREENERS]: [],
    targetingCriteria: false,
    patientsCriteria: false,
}
export const sliceName = "PriceChartSlice";

export const priceChartSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        handlePCReset: () => initialState,
        handlePCIndustry: (state, action) => {
            return { ...state, industry: action.payload }
        },
        handlePCGeographies: (state, action) => {
            if (state.geographies.includes(action.payload)) {
                return { ...state, geographies: state.geographies.filter(title => title !== action.payload) }
            }
            else {
                return { ...state, geographies: [...state.geographies, action.payload] }
            }
        },
        handleDefaultPCTitles: (state, action) => {
            return { ...state, titles: [action.payload] }
        },
        handlePCTitles: (state, action) => {
            if (state.titles.includes(action.payload)) {
                return { ...state, titles: state.titles.filter(title => title !== action.payload) }
            }
            else {
                return { ...state, titles: [...state.titles, action.payload] }
            }
        },
        handleDefaultPCTargetables: (state, action) => {
            return { ...state, targetable_screeners: [] }
        },
        handlePCTargetables: (state, action) => {
            if (state.targetable_screeners.includes(action.payload)) {
                return { ...state, targetable_screeners: state.targetable_screeners.filter(title => title !== action.payload) }
            }
            else {
                return { ...state, targetable_screeners: [...state.targetable_screeners, action.payload] }
            }
        },
        handleDefaultPCIRLevel: (state, action) => {
            return { ...state, ir_level: [] }
        },
        handlePCIRLevels: (state, action) => {
            if (state.ir_level.includes(action.payload)) {
                return { ...state, ir_level: state.ir_level.filter(title => title !== action.payload) }
            }
            else {
                return { ...state, ir_level: [...state.ir_level, action.payload] }
            }
        },
    }
})

export const priceChartDataState = state => state[sliceName]

export const { handlePCReset,
    handlePCIndustry,
    handlePCTitles,
    handleDefaultPCTitles,
    handlePCGeographies,
    handleDefaultPCTargetables,
    handlePCTargetables,
    handleDefaultPCIRLevel,
    handlePCIRLevels } = priceChartSlice.actions

export default priceChartSlice.reducer